import { ComponentType } from "react";
import { Helmet } from "react-helmet-async";

interface Props {
    title?: string;
    description?: string;
    keywords?: string;
    Component: ComponentType<any>;
    componentProps?: Record<string, any>;
}

const Helmetify = ({ title, description, keywords, Component, componentProps }: Props) => {
    return (
        <>
            <Helmet>
                {title && <title>{`Shopend - ${title}`}</title>}
                {description && <meta name="description" content={description} />}
                {keywords && <meta name="keywords" content={keywords} />}
            </Helmet>
            <Component {...componentProps} />
        </>
    );
};

export default Helmetify;
